module.exports = "<p>\n  sharedcustomerinfoonly works!\n</p>\n"